import React from "react";
import useStringInput, { StringInput } from "@/components/form/string-input";
import useRadioInput, { RadioInput } from "@/components/form/radio-input";
import Wrapper from "@/scenes/_shared/stages/wrapper";
import useEmailInput, { EmailInput } from "@/components/form/email-input";
import usePhoneInput, { PhoneInput } from "@/components/form/phone-input";

const S01 = (props) => {
    const user = useStringInput({
        name: "client[name]", label: "Hva er ditt navn?",
        className: "mt-7",
        placeholder: "Legg ved fullt navn",
        ...props,
    })

    const email = useEmailInput({
        name: "client[email]", label: "Epost-adresse",
        placeholder: "eksempel@epost.no",
        ...props,
    })

    const phone = usePhoneInput({
        name: "client[phone]", label: "Telefonnummer",
        placeholder: "00 00 00 00",
        ...props,
    })

    const radio = useRadioInput({
        name: "client[type]", label: "Er du kjøper eller selger?",
        className: "mt-7",
        options: {
            data: [
                { label: "Kjøper", value: "BUYER" },
                { label: "Selger", value: "SELLER" },
            ],
        },
        ...props,
    })

    return (
        <Wrapper {...props} header="Fortell oss hvem du er">
            <p>
                Gikk ikke kjøpet helt som planlagt? Fyll ut og svar på spørsmålene nedenfor, så vil en av våre dyktige jurister forsøke å hjelpe med en løsning.
            </p>

            <StringInput {...user.props}/>

            <div className="group mt-7 gg-3">
                <EmailInput {...email.props}/>
                <PhoneInput {...phone.props}/>
            </div>

            <RadioInput {...radio.props}/>
        </Wrapper>
    );
};

export default S01;
